import React from "react";
import ConfirmationModal from "app/components/common/ConfirmationModal";

const UpdateAgentConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  isLoading,
}) => {
  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      title="Update Agent Info?"
      confirmLabel="Update"
      confirmVariant="primary"
      isLoading={isLoading}
      loadingLabel="Updating..."
      className="update-agent-modal-wrapper"
    >
      <div className="my-3">
        <ul>
          <li>
            Updated Agent info will apply to existing jobs with this agent.
          </li>
          <li>
            This won't affect existing reports. To apply the changes, please
            recompile the reports.
          </li>
        </ul>
      </div>
    </ConfirmationModal>
  );
};

export default UpdateAgentConfirmationModal;
